'use strict';

class videoPlayer {

    constructor() {

        const $ = require('jquery');
        const Vimeo = require('./../../../../build/node_modules/@components/vimeo/dist/player.js');

        let $iframes = $('.ce-video iframe');

        if ($iframes.length > 0) {

            $iframes.each(function () {
                let player = new Vimeo(iframe);
                let $playControl = $(iframe).siblings('[data-control-play]');

                $playControl.on('click', function () {

                    player.play();
                    $(this)
                        .closest('.video-container')
                        .addClass('is-playing');

                });

            });

        }

    }

}

module.exports = videoPlayer;
